/**
 * Resolves the effective product ID for planning: alias products map to their main product.
 * Used so that demands for alias products are grouped with the main product in sequence and batch determination.
 *
 * @param materialId UUID of the material (may be main product or alias)
 * @param materials List of materials with uuid, isAlias?, aliasForProductUuid?
 * @returns UUID of the main product to use for grouping (same as materialId if not an alias)
 */
export function getEffectiveMaterialId(
  materialId: string | undefined,
  materials: Array<{ uuid?: string; isAlias?: boolean; aliasForProductUuid?: string }>
): string | undefined {
  if (!materialId) return undefined;
  const material = materials.find((m) => m.uuid === materialId);
  if (!material) return materialId;
  if (material.isAlias && material.aliasForProductUuid) {
    return material.aliasForProductUuid;
  }
  return materialId;
}
